export default __webpack_public_path__ + "static/media/release-but-not-yet-bookable.71143c3e.svg";